<template>
  <client-only>
    <div>
      <v-row wrap class :class="compClass" no-gutters id="search-input-wrpper">
        <v-col
          :cols="employment ? 12 : isSticky && !isIndex ? 12 : isIndex ? 12 : 5"
          :sm="!employment ? 5 : ''"
          class="mb-md-0 px-1 pt-0"
        >
          <v-combobox
            ref="input"
            v-model="model"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            :placeholder="placeholder"
            class="search-input"
            :class="compClass"
            item-text="displayString"
            item-value="typeRelativeId"
            :color="employment ? 'white' : 'primary'"
            solo
            :background-color="employment ? '#1a1e28' : 'white'"
            :outlined="employment ? false : true"
            dense
            :flat="employment ? false : true"
            filled
            no-filter
            allow-overflow
            maxlength="40"
            autocomplete="off"
            clearable
            hide-no-data
            hide-details
            persistent-hint
            return-object
            validate-on-blur
            :menu-props="{
              contentClass:
                'smart-combo display-18   px-3 scrollbar-3 text-right menu-props-class font-weight-medium',
              closeOnClick: false,
              closeOnContentClick: false,
              openOnClick: false,
              bottom: true,
            }"
            @keyup.enter="onEnter"
            @focus="scorllTop"
            :prepend-inner-icon="employment ? '' : 'icon-forma-1-copy-4'"
            append-icon=""
            data-cy="what-input"
          ></v-combobox>
        </v-col>

        <v-col v-if="employment">
          <v-divider dark></v-divider>
        </v-col>

        <v-col
          :cols="employment ? 12 : isSticky && !isIndex ? 12 : isIndex ? 12 : 5"
          :sm="!employment ? 5 : ''"
          :class="isSticky && !isIndex ? 'mt-3' : isIndex ? 'mt-3' : 'mt-0 '"
          class="py-0 px-1 mt-sm-0 auto-suggest-top"
        >
          <AutoSuggest
            class="primary--text"
            input-class=" "
            :employment="employment"
            :class="compClass"
            :placeholder="geoLexPlaceholder"
            :searchProperties="searchProperties"
            @distanceSelected="updateDistanceSelection"
            @locationSelected="updateSuggestedLocation"
            @locationDeleted="handleDeletePrevLocation"
          />
        </v-col>
        <v-col v-if="employment">
          <v-divider dark></v-divider>
        </v-col>

        <v-col
          :cols="employment ? 12 : isSticky && !isIndex ? 12 : isIndex ? 12 : 1"
          :sm="!employment ? '2' : ''"
          :class="
            employment
              ? 'employment-page'
              : isSticky && !isIndex
              ? 'mt-4'
              : isIndex
              ? 'mt-4'
              : 'mt-0 '
          "
          class="mt-sm-0 d-flex px-1"
          align-self="center"
        >
          <DrBtn
            v-if="!employment"
            :type-btn="'search-btn display-18 small cy-search-btn'"
            :action="submitSearch"
            :btn-enabled="disableSend"
          >
            חיפוש
          </DrBtn>

          <p v-else class="text-left">
            <img
              src="/employment_index/arrow02.png"
              width="52px"
              alt="search"
              @click="submitSearch"
              v-show="!disableSend"
              class="v-align-end pt-3"
            />
          </p>
        </v-col>
      </v-row>
    </div>
  </client-only>
</template>

<script>
import drushim_lodash from 'lodash';
import * as lib from './lib';
import SearchParams from '@/lib/enums/SearchParams';
import SearchBaseVue from '@/components/HomePageComponents/Search/SearchBase.vue';
import AutoSuggest from '@/components/AutoSuggest2/AutoSuggest.vue';

export default {
  extends: SearchBaseVue,

  components: {
    AutoSuggest
  },

  props: {
    isSticky: {
      type: Boolean,
      default: true
    },
    isIndex: {
      type: Boolean,
      required: false,
      default: true
    },
    layoutClass: {
      type: Object
    },
    noScroll: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    geoLexPlaceholder: {
      type: String
    },
    inputClass: {
      type: String,
      default: ''
    },

    searchProperties: {
      type: Object,
      required: false,
      default: () => {}
    },
    isWizard: {
      type: Boolean,
      required: false,
      default: false
    },
    employment: {
      Boolean
    }
  },

  data() {
    return {
      isLoading: false, // fetching data in progress
      isSearching: false, // user is entering search input - used to show empty list (see @EmptyList)
      model: null, // selected item
      search: null, // search value
      resultList: null, // server response
      cache: new Map(),
      disableSend: true,
      autoSuggestModel: null,
      distanceModel: {} // DEFAULT_DISTANCE,
    };
  },

  computed: {
    isCorona() {
      return drushim_lodash.includes(this.$route.path, 'קורונה');
    },

    items() {
      const emptyList = this.emptyList();
      return emptyList || lib.getItems(this.resultList);
    },

    isFreeSearch() {
      if (
        this.model &&
        drushim_lodash.get(this.model, SearchParams.STS.SearchTypeIdentifier)
      ) {
        return false;
      }
      return !!this.search; // convert string to bool
    },
    isCompanySearch() {
      let isCompanySearch = false;
      if (typeof this.model === SearchParams.Types.Object) {
        let isCompany = drushim_lodash.get(this.model, 'type', false);
        if (isCompany === SearchParams.STS.SearchByCompanyName) {
          isCompanySearch = true;
        }
      }
      return isCompanySearch;
    },
    isJD() {
      let isJd = false;
      if (typeof this.model === SearchParams.Types.Object) {
        let jd = drushim_lodash.get(this.model, 'type', false);
        if (jd === SearchParams.STS.Jd) {
          isJd = true;
        }
      }
      return isJd;
    },

    compClass() {
      return this.employment
        ? 'employment-page'
        : this.inputClass + 'primary--text';
    }
  },

  watch: {
    // triggers autocomplete
    search(newVal) {
      if (typeof this.search === 'string') {
        this.search = this.search.trim();
        this.search = this.search.replace('/ ', '/');
        this.search = this.search.replace(' /', '/');
        this.search = this.search.replace('  ', ' ');
      }

      if (this.search === '') {
        this.search = '';
        this.model = null;
        return;
      }
      this.isSearching = true;
      this.$emit('search', newVal);
    },

    model() {
      if (!drushim_lodash.isNil(this.model)) this.disableSend = false;
    },

    autoSuggestModel() {
      if (!drushim_lodash.isEmpty(this.autoSuggestModel)) {
        this.disableSend = false;
      }
    },

    searchProperties() {
      this.setInputValueAsProp();
    }
  },

  mounted() {
    this.compClass;
    this.onSearch = drushim_lodash.debounce(this.onSearch, 250);

    this.$on('search', this.onSearch);
    this.setInputValueAsProp();
  },

  methods: {
    setInputValueAsProp() {
      // set initial value if provided as prop
      if (this.searchProperties) {
        const whatFieldText = this.searchProperties.WhatFieldText;
        this.search = whatFieldText;

        if (
          this.searchProperties.subcat &&
          this.searchProperties.subcat.length > 0
        ) {
          this.model = {
            [SearchParams.STS.DisplayString]: whatFieldText,
            [SearchParams.STS.SearchType]: SearchParams.STS.SearchBySubCategory,
            [SearchParams.STS.SearchTypeIdentifier]: this.searchProperties
              .subcat
          };
        } else if (this.searchProperties.catdir) {
          this.model = {
            [SearchParams.STS.DisplayString]: whatFieldText,
            [SearchParams.STS.SearchType]: SearchParams.STS.SearchByCategory,
            [SearchParams.STS.SearchTypeIdentifier]: this.searchProperties
              .catdir
          };
        } else {
          this.model = {
            [SearchParams.STS.DisplayString]: this.search
          };
        }
      }
    },

    /**
     * @focus scroll page to Autocomplete field  ' only on mobile
     */
    scorllTop() {
      if (this.noScroll) return;

      if (this.$vuetify.breakpoint.xsOnly) {
        const elmnt = document.querySelector('.home-board-hdr');
        elmnt.scrollIntoView();
      }
    },

    onEnter(event) {
      this.submitSearch();
    },

    onSearch(newVal) {
      if (!newVal) return;
      if (!drushim_lodash.isString(newVal) || drushim_lodash.isEmpty(newVal.trim())) return;

      // check before continue
      newVal = newVal.trim();
      if (this.isLoading) {
        this.isSearching = false;
        return;
      }

      this.isLoading = true;

      this.loadSearchSuggestions(newVal)
        .catch(err => console.log(err))
        .then(res => {
          this.resultList = drushim_lodash.cloneDeep(res.resultList);
          return res;
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.isLoading = false;
          this.isSearching = false;
        });
    },

    /**
     * Load suggestions by search String
     * @param {string} searchVal - search value
     * @returns {Promise} fetch request resolved with suggestions data
     */
    loadSearchSuggestions(searchVal) {
      if (this.cache.has(searchVal)) {
        return this.cache.get(searchVal);
      }

      const data = {
        parameters: [
          { name: 'suggestPrefix', value: searchVal },
          {
            name: 'suggestTypes',
            value: [lib.returnRelevantSearchFlags()].join()
          }
        ]
      };
      return lib.loadSuggestions({ data }, this.$axios).then(res => {
        this.cache.set(searchVal, Promise.resolve(res));
        return res;
      });
    },

    emptyList() {
      const emptyList = [];

      // if empty search string
      if (!this.search) return emptyList;

      // if still searching
      if (this.isSearching) return emptyList;

      // item already selected from list
      if (drushim_lodash.get(this.model, SearchParams.STS.DisplayString) === this.search)
        return emptyList;

      return null;
    },

    updateDistanceSelection(value) {
      this.distanceModel = value;
    },

    updateSuggestedLocation(value) {
      this.autoSuggestModel = value;
    },

    handleDeletePrevLocation() {
      this.autoSuggestModel = null;
    },

    validateWhere() {
      if (
        this.autoSuggestModel &&
        this.autoSuggestModel.displayString &&
        this.autoSuggestModel.typeRelativeId
      ) {
        return true;
      } else {
        this.autoSuggestModel = null;
        return false;
      }
    },

    submitSearch() {
      if (
        (this.model && drushim_lodash.get(this.model, SearchParams.STS.DisplayString)) ||
        this.isFreeSearch ||
        this.validateWhere()
      ) {
        let payload = {
          isFreeSearch: this.isFreeSearch,
          isJD: this.isJD,
          isCompanySearch: this.isCompanySearch,
          searchterm: this.isFreeSearch ? this.search : this.model,
          jdTerm: this.isJD ? this.model[SearchParams.STS.DisplayString] : null,
          location: this.autoSuggestModel,
          distance: this.distanceModel
        };

        if (this.isWizard) {
          payload = this.getWizardModel(payload);
        }
        this.$emit('autocompleteSearch', payload);
      }
    },

    getWizardModel(payload) {
      let wizardObject = {
        subcat: undefined,
        catdir: undefined,
        city: undefined,
        range: undefined
      };

      if (payload.searchterm) {
        if (payload.searchterm.type === SearchParams.STS.SearchBySubCategory) {
          wizardObject.subcat =
            payload.searchterm[SearchParams.STS.SearchTypeIdentifier];
        } else {
          wizardObject.catdir =
            payload.searchterm[SearchParams.STS.SearchTypeIdentifier];
        }
      }

      if (
        payload.location &&
        payload.location.displayString &&
        payload.location.typeRelativeId
      ) {
        wizardObject.city = payload.location.drushim_region_ids
          .split(SearchParams.STS.RegionSeparator)
          .join(SearchParams.Constants.MultipleSeparator);

        wizardObject.range = payload.distance.Code;
      }

      return wizardObject;
    }
  },

  beforeDestroy() {
    this.model = null;
    this.search = '';
    this.disableSend = true;
    this.distanceModel = undefined;
    this.$off('search');
  }
};
</script>

<style lang="scss" scoped>
.above-all {
  z-index: 600;
}

.employment-page {
  background-color: #1a1e28 !important;
  flex-direction: column;
  color: white !important;
}

@media screen and (max-width: 600px) {
  .sticky-layout .sticky-hide {
    display: none;
  }
  .sticky-layout.is-editing .sticky-hide {
    display: block;
    margin-top: 0 !important;
  }
  .sticky-layout #SearchManager {
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .sticky-layout
    #AutoCompleteSearchBox
    #AutoCompleteSearch
    #search-input-wrpper {
    flex-direction: row;
    flex-wrap: nowrap;
  }
}
</style>
